import React, { useEffect, useState } from "react";
import Panic_Healing_Banner from "./panic_healing_banner/Panic_Healing_Banner";
import Content_Component from "./content_component/Content_Component";
import Orange_Btn from "../common/common_btn/orange_btn/Orange_Btn";
import './Panic_Healing.css'
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { SingleSpandanSessionType } from "../../features/admin/spandan/Slice";
import { decodeId } from "../../utils/common";

const Panic_Healing = () => {
  const navigate = useNavigate()
  const { id } = useParams();

  const currentData = useSelector((state) => state.spandan.spandan_session_type);
  const dispatch = useDispatch()


  useEffect(() => {
    dispatch(SingleSpandanSessionType(decodeId(id)))
  }, [id, dispatch]);


  return (
    <section className="Panic_Healing">
      <Panic_Healing_Banner data={currentData} />
      <Content_Component data={currentData} />

      <div className="floating_regster_btn">
        <p className="inner_text">
          Want to experience the <b>spirit of Spandan?</b>
        </p>
        <div className="register_btn">
          <Orange_Btn btnText={"Register Now!"} onClick={() => { navigate("/spandan-register-form") }} />
        </div>
      </div>
    </section>
  );
};

export default Panic_Healing;
